/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SessionItem } from '../../models/session-item';

export interface AuthSessions$Plain$Params {
}

export function authSessions$Plain(http: HttpClient, rootUrl: string, params?: AuthSessions$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SessionItem>>> {
  const rb = new RequestBuilder(rootUrl, authSessions$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SessionItem>>;
    })
  );
}

authSessions$Plain.PATH = '/api/v1/auth/sessions';
